import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Helper para combinar clases de Tailwind sin conflictos.
// Uso: cn('px-4 py-2', isActive && 'bg-blue-500', className)
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs))
